import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
  {
    pregunta: "¿Cuántas sesiones necesito para notar mejoría?",
    respuesta: "Depende de cada caso. Muchos pacientes notan mejoría desde la primera sesión, pero para problemas crónicos suelen necesitarse entre 3-5 sesiones. En la primera consulta evaluaré tu caso y te daré una estimación personalizada."
  },
  {
    pregunta: "¿Duele el tratamiento de osteopatía?",
    respuesta: "No, la osteopatía utiliza técnicas suaves y no invasivas. Puedes sentir cierta presión durante las manipulaciones, pero nunca dolor. El objetivo es restaurar la movilidad de forma natural y confortable."
  },
  {
    pregunta: "¿Ofrecen servicio a domicilio?",
    respuesta: "Sí, ofrecemos servicio a domicilio en Madrid y alrededores. Contacta con nuestra secretaria para consultar disponibilidad y tarifas para este servicio personalizado."
  },
  {
    pregunta: "¿Los bonos de sesiones caducan?",
    respuesta: "No, los bonos nunca caducan. Además, puedes compartirlos con familiares o amigos. El bono de 3 sesiones cuesta 140€ y el de 5 sesiones 220€, lo que supone un ahorro significativo."
  },
  {
    pregunta: "¿Qué debo llevar a mi primera cita?",
    respuesta: "Solo necesitas venir con ropa cómoda. Si tienes pruebas médicas recientes (radiografías, resonancias, informes), tráelas para que pueda revisarlas. Te recomiendo no comer mucho justo antes de la sesión."
  },
  {
    pregunta: "¿Trabajas con seguros médicos?",
    respuesta: "Actualmente trabajo de forma privada, pero te proporciono factura para que puedas presentarla a tu seguro si tienen cobertura para terapias manuales. Consulta con tu aseguradora."
  },
  {
    pregunta: "¿Puedo aparcar cerca de la consulta?",
    respuesta: "Sí, la zona de Fuenlabrada tiene aparcamiento en la calle y también hay parkings públicos cercanos. La consulta está ubicada en el Herbolario Tu Equilibrio Personal, en Calle Murcia 1."
  },
  {
    pregunta: "¿Atiendes urgencias?",
    respuesta: "Para urgencias médicas debes acudir a un centro de salud. Sin embargo, si tienes un dolor agudo que no es urgencia médica, contacta por WhatsApp y veré si puedo atenderte lo antes posible."
  }
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-[var(--bg-subtle)]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-2 mb-4">
              <HelpCircle size={40} className="text-[var(--brand-dark)]" />
              <h2 className="heading-1">Preguntas frecuentes</h2>
            </div>
            <p className="body-large max-w-2xl mx-auto">
              Respuestas a las dudas más comunes sobre mis tratamientos y servicios
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div 
                key={index}
                className="network-card overflow-hidden"
                data-testid={`faq-item-${index}`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-[var(--bg-subtle)] transition-colors"
                  aria-expanded={activeIndex === index}
                >
                  <span className="heading-3 pr-4">{faq.pregunta}</span>
                  {activeIndex === index ? (
                    <ChevronUp className="flex-shrink-0 text-[var(--brand-dark)]" size={24} />
                  ) : (
                    <ChevronDown className="flex-shrink-0 text-[var(--brand-dark)]" size={24} />
                  )}
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-6">
                    <p className="body-medium text-[var(--text-secondary)]">
                      {faq.respuesta}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
